import React from "react";
import { Typography, Box } from "@mui/material";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  align?: "left" | "center" | "right";
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  align = "center",
}) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h1" component="h1" gutterBottom align={align}>
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="h2"
          component="h2"
          gutterBottom
          align={align}
          color="text.secondary"
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default PageHeader;
